export default {
  'applications.title': 'Manage Requests',
  'applications.detail.title': 'Request Details {name}',
  'applications.bulkDetail.title': 'Bulk Task Details {name}',
  'applications.detail.application': 'Request',
  'applications.complete.title': 'Complete Information {name}',
  'applications.text.resendNotification': 'Resend Notification',
  'applications.text.versionHistory': 'Version History',
  'applications.text.loadingText': 'Loading information',
  'applications.text.actions': 'Actions',
  'applications.text.variables': 'Variables',
  'applications.text.template': 'Template',
  'applications.text.capacitation': 'Trainings',
  'applications.text.attachment': 'Attach worker payment receipt',
  'applications.history.title1': 'History',
  'applications.history.title': 'Select the step you want to review',
  'applications.history.subTitle':
    'This action will show the documentation uploaded up to that date:',
  'applications.history.current': 'Current',
  'applications.history.return': 'Return',
  'applications.history.previous': 'Previous',
  'applications.text.form': 'Form',
  'applications.text.forms': 'Forms',
  'applications.text.comments': 'Comments',
  'applications.comments.empty.title': 'Comments',
  'applications.comments.empty.description': 'Comments help you chat with users within a request.',
  'applications.comments.empty.cta': "Let's send your first comment",
  'applications.comments.empty.alt': 'Comments illustration',
  'applications.comments.mentions.empty': 'No users found',
  'applications.comments.actions.edit': 'Edit comment',
  'applications.comments.actions.save': 'Save',
  'applications.comments.actions.cancel': 'Cancel',
  'applications.comments.actions.delete': 'Delete comment',
  'applications.comments.actions.update': 'Edit',
  'applications.comments.actions.delete.confirm': 'Delete this comment?',
  'applications.comments.actions.delete.ok': 'Delete',
  'applications.comments.actions.delete.cancel': 'Cancel',
  'applications.comments.actions.delete.description': 'This comment will be permanently removed.',
  'applications.comments.edit.validation': 'Please write a comment before saving.',
  'applications.comments.edit.title': 'Edit comment',
  'applications.text.notifyUsers': 'Notify Users',
  'applications.text.writeComment': 'Write a Comment',
  'applications.text.mailsTracking': 'Email Tracking',
  'applications.text.engine': 'Engine Tasks',
  'applications.text.traces': 'Traces',
  'applications.text.reassignedTasks': 'Reassigned Tasks',
  'applications.text.reassigned.sourceUser': 'Source User',
  'applications.text.reassigned.destinationUser': 'Destination User',
  'applications.text.reassigned.reason': 'Reason',
  'applications.text.reassigned.detailTitle': 'Reassigned Task Detail',
  'applications.text.commandTraces': 'Commands',
  'applications.text.command.commandType': 'Type',
  'applications.text.command.detailTitle': 'Command Detail',
  'applications.text.command.data': 'Data',
  'applications.text.commandType.details': 'Details',
  'applications.text.commandType.approve': 'Approve',
  'applications.text.commandType.reject': 'Reject',
  'applications.text.commandType.complete': 'Completed',
  'applications.text.commandType.executeTask': 'Executed',
  'applications.text.commandType.sign': 'Sign',
  'applications.text.commandType.cancel': 'Cancel Request',
  'applications.text.commandType.void': 'Void Request',
  'applications.text.commandType.sendNotifications': 'Resend Notifications',
  'applications.text.commandType.evaluateApprovers': 'Evaluate Approvers',
  'applications.text.commandType.backToStep': 'Revert Request',
  'applications.text.commandType.reassignTask': 'Reassign Task',
  'applications.text.commandType.executeAutomaticAction': 'Execute Automatic Action',
  'applications.text.commandType.history': 'Version History',
  'applications.text.commandType.continue': 'Edit',
  'applications.text.commandType.autoAssignTask': 'Auto-assign Task',
  'applications.text.commandType.goToStep': 'Advance Request',
  'applications.text.commandType.removeProcessInstance': 'Remove Request',
  'applications.text.commandType.clearError': 'Reevaluate Error',
  'applications.text.commandType.startRequest': 'Start Request',
  'applications.text.commandType.goToActionFromCustomCommand': 'Go to Action from Custom Command',
  'applications.text.commandType.aiInteract': 'Interact with AI',
  'applications.text.engine.id': 'ID',
  'applications.text.engine.number': 'Number',
  'applications.text.engine.operationType': 'Operation Type',
  'applications.text.engine.status': 'Status',
  'applications.text.engine.importance': 'Importance',
  'applications.text.engine.created': 'Created',
  'applications.text.engine.scheduledDate': 'Scheduled Date',
  'applications.text.engine.observations': 'Observations',
  'applications.text.engine.status.pending': 'Pending',
  'applications.text.engine.status.processing': 'Processing',
  'applications.text.engine.status.processed': 'Processed',
  'applications.text.engine.status.error': 'Error',
  'applications.text.engine.status.skipped': 'Skipped',
  'applications.text.engine.status.cancelled': 'Cancelled',
  'applications.text.engine.status.failed': 'Failed',
  'applications.text.engine.status.unknown': 'Unknown',
  'applications.text.engine.importance.none': 'None',
  'applications.text.engine.importance.low': 'Low',
  'applications.text.engine.importance.medium': 'Medium',
  'applications.text.engine.importance.high': 'High',
  'applications.text.engine.importance.urgent': 'Urgent',
  'applications.text.engine.importance.critical': 'Critical',
  'applications.text.engine.importance.unknown': 'Unknown',
  'applications.text.engine.operationType.evaluateApprovers': 'Evaluate Approvers',
  'applications.text.engine.operationType.handleNotifications': 'Send Notifications',
  'applications.text.engine.operationType.handleAutomaticActions': 'Manage Automatic Action',
  'applications.text.engine.operationType.handleOverdue': 'Manage Expiration',
  'applications.text.engine.operationType.handleApprovalReminderNotifications':
    'Send Approval Reminder Notifications',
  'applications.text.engine.operationType.handleIteration': 'Manage Automatic Action / Iteration',
  'applications.text.engine.operationType.handleEntityOperation':
    'Manage Automatic Action / Dynamic Entity Operation',
  'applications.text.engine.operationType.attachmentsCopy': 'Copy Attachments',
  'applications.text.engine.operationType.handleFinishCompleteInformationCompleted':
    'Handling Completion of Action to Complete Information Completed',
  'applications.text.engine.processingDate': 'Processing Date',
  'applications.text.engine.processedDate': 'Processed Date',
  'applications.text.engine.processingAttempts': 'Processing Attempts',
  'applications.text.engine.detailTitle': 'Engine Task Details',
  'applications.loading.results': 'Loading results',
  'applications.text.tabDocumentsTitle': 'Your documents ({count})',
  'applications.text.errorTitle': 'Request with Errors',
  'applications.text.securityCode': 'PIN',
  'applications.text.itemsAffected': 'Affected Elements',
  'applications.text.itemsCount': 'Elements Count',
  'applications.text.insertItems': 'Elements to Add',
  'applications.text.opsResultStatus': 'Operation Result Status',
  'applications.text.handlerType': 'Handler Type',
  'applications.text.model': 'Model',

  'applications.text.observations': 'Observations',
  'applications.text.chatMessageContent': 'Message Content',
  'applications.text.chatInternalTaskId': 'Chat Internal Task ID',
  'applications.text.scheduledExecution.description': 'Finished Date',
  'applications.text.executeApiCall.results': 'API Call Results',
  'applications.text.executeApiCall.result': 'API Call Result',
  'applications.text.integration.description': 'Function',
  'applications.text.integration.results': 'API Call Result',
  'applications.text.dynamicEntityOperation.results': 'Dynamic Entity Operation Results',
  'applications.text.dynamicEntityOperation.result': 'Dynamic Entity Operation Result',
  'applications.text.dynamicEntityOperation.description': 'Operation',
  'applications.text.sharePointOperation.description': 'Operation',
  'applications.text.consumeSequence.results': 'Consume Sequence Operation Result',
  'applications.text.consumeSequence.description': 'Pattern',
  'applications.text.executeRpaFlow.results': 'RPA Call Results',
  'applications.text.executeRpaFlow.result': 'RPA Call Result',
  'applications.text.executeRpaFlow.description': 'RPA Flow',
  'applications.text.internalOperation.results': 'Internal Operation Results',
  'applications.text.internalOperation.result': 'Internal Operation Result',
  'applications.text.internalOperation.success': 'Success',
  'applications.text.internalOperation.error': 'Error',
  'applications.text.internalOperation.operationStatus': 'Operation Status',
  'applications.text.internalOperation.type': 'Operation Type',
  'applications.text.internalOperation.successDescription': 'Operation completed {status}',
  'applications.text.mappingFilters': 'Mapping Filters',
  'applications.text.mappingTableFilters': 'Mapping Table Filters',
  'applications.text.updateValues': 'Update Values',
  'applications.text.affectedItems': 'Items Affected',
  'applications.text.itemsAffected.one': 'One',
  'applications.text.itemsAffected.all': 'All',
  'applications.text.itemsAffected.custom': 'Custom',
  'applications.text.internalOperationType.search': 'Search',
  'applications.text.internalOperationType.add': 'Add',
  'applications.text.internalOperationType.modify': 'Modify',
  'applications.text.internalOperationType.activate': 'Activate',
  'applications.text.internalOperationType.deactivate': 'Deactivate',
  'applications.text.internalOperationType.remove': 'Remove',
  'applications.text.internalOperationType.count': 'Count',
  'applications.text.internalOperationType.canceldelegation': 'Cancel Delegation',
  'applications.text.conditional.results': 'Conditional Evaluation Result',
  'applications.text.executeQuery.description': 'Database Name',
  'applications.text.executeQuery.extra': 'Database Query',
  'applications.text.setVariable.results': 'Set Variable Operation Result',
  'applications.text.setFormData.results': 'Set Form Data Operation Result',
  'applications.text.iterate.description': 'Dynamic Entity',
  'applications.text.iterate.table': 'Table to Iterate',
  'applications.text.iterate.form': 'Form to Iterate',
  'applications.text.iterate.attachment': 'Field Attachment to Iterate',
  'applications.text.iterate.entity': 'Entity to Iterate',
  'applications.text.iterate.results': 'Iteration Results',
  'applications.text.switch.results': 'Evaluation Result',
  'applications.text.internalOperation.description': 'Internal Operation Entity',
  'applications.text.internalOperation.results': 'Internal Operation Result',
  'applications.text.startProcessInstance.description': 'Process Description',
  'applications.text.completeInformation.results': 'Webhook Operation Result',
  'applications.text.sendEmail.results': 'Send Email Results',
  'applications.text.sendEmail.result': 'Send Email Result',
  'applications.text.openAi.results': 'Open AI Call Results',
  'applications.text.openAi.result': 'Open AI Call Result',
  'applications.text.automyAi.results': 'Automy AI Results',
  'applications.text.automyAI.result': 'Automy AI Result',
  'applications.text.automyAI.chatWithAgent': 'Interact',
  'applications.text.runCode.results': 'Operation Results',
  'applications.text.runCode.result': 'Operation Result',
  'applications.text.sendMail.details': 'Details',
  'applications.text.sendMail.history': 'Event History',
  'applications.text.googleIntegration.description': 'Service',
  'applications.text.executeProcessAction.description': 'Process',
  'applications.text.googleIntegration.extra': 'Operation',
  'applications.text.googleIntegration.connection': 'Connection',
  'applications.text.whatsAppBusinessIntegration.connection': 'Connection',
  'applications.text.whatsAppBusinessIntegration.description': 'Operation Type',
  'applications.text.overdue.description': 'Due Date and Time',
  'applications.text.ftpOperation.description': 'Operation',
  'applications.text.runCode.description': 'Language',
  'applications.text.runCode.status': 'Status',
  'applications.text.runCode.status.pending': 'Pending',
  'applications.text.runCode.status.installing': 'Installing',
  'applications.text.runCode.status.running': 'Running',
  'applications.text.runCode.status.completed': 'Completed',
  'applications.text.runCode.status.failed': 'Failed',
  'applications.text.runCode.status.expired': 'Expired',
  'applications.text.runCode.status.error': 'Error',
  'applications.text.runCode.status.notfound': 'Not Found',

  'applications.text.rpaInstanceSendStatus.pending': 'Pending',
  'applications.text.rpaInstanceSendStatus.sent': 'Sent',
  'applications.text.rpaInstanceSendStatus.error': 'Error',
  'applications.text.rpaInstanceSendStatus.offlineAgent': 'Offline Agent',

  'applications.text.rpaInstanceResponseStatus.pending': 'Pending',
  'applications.text.rpaInstanceResponseStatus.success': 'Success',
  'applications.text.rpaInstanceResponseStatus.error': 'Error',
  'applications.text.responseTicket': 'Response Ticket',
  'applications.text.lastStatusCheckDate': 'Last Status Check Date',
  'applications.text.finishedDateTime': 'Finished Date Time',
  'applications.text.iterateSteps': 'Iteration Steps',
  'applications.text.automyAi.description': 'Agent',

  'applications.text.sendMail.to': 'To',
  'applications.text.sendMail.replyTo': 'Reply To',
  'applications.text.sendMail.subject': 'Subject',
  'applications.text.sendMail.messageId': 'Message ID',
  'applications.text.sendMail.uniqueArgs': 'Unique Args.',
  'applications.text.sendMail.from': 'From',
  'applications.text.sendMail.cc': 'CC',
  'applications.text.sendMail.bcc': 'BCC',
  'applications.text.sendMail.responseCode': 'Response Code',
  'applications.text.sendMail.errorMessage': 'Error Message',

  'applications.text.progress': 'Completed',
  'applications.text.moreActions': 'Other Actions',
  'applications.text.originIp': 'Origin IP',
  'applications.text.parameters': 'Parameters',
  'applications.text.insertedData': 'Inserted Data',

  'applications.text.entityOperation': 'Operation',
  'applications.text.created': 'Creation Date',
  'applications.text.executionOrder': 'Execution Order',
  'applications.text.affectedItems': 'Affected Items',
  'applications.text.startedDateTime': 'Start Processing',
  'applications.text.finishedDateTime': 'Completion Date',
  'applications.text.data': 'Data',
  'applications.text.updated': 'Updated Date',
  'applications.text.processingAttempts': 'Processing Attempts',

  'application.text.iterationDynamicEntity': 'Dynamic Entity: {name}',
  'application.text.iterationForm': 'Form: {name}',
  'application.text.iterationTable': 'Table: {name}',

  'applications.text.sendStatus': 'Send Status',
  'applications.text.sentData': 'Sent Data',
  'applications.text.responseStatus': 'Response Status',

  'applications.text.entity': 'Entity',
  'applications.text.dynamicEntity.operation': 'Dynamic Entity Operation',
  'applications.text.dynamicEntity.affected': 'Affected Items',
  'applications.text.dynamicEntity.quantity': 'Items Quantity',
  'applications.text.dynamicEntity.filters': 'Filters',
  'applications.text.dynamicEntity.tableFilters': 'Filters / Table',
  'applications.text.dynamicEntity.response': 'Response',

  'applications.text.documents': 'Documents',
  'applications.text.generatedDocuments': 'Generated Documents',
  'applications.text.loadingMore': 'Loading additional configurations...',

  'applications.text.sendNotifications': 'The notification has been resent.',
  'applications.text.approveNotification': 'The request has been approved.',
  'applications.text.voidNotification': 'The request has been rejected.',
  'applications.text.cancelNotification': 'The request has been canceled.',

  'variablesInfo.internalName': 'Internal Name',
  'variablesInfo.type': 'Type',
  'variablesInfo.initialValue': 'Initial Value',

  'applications.text.bulkTask.detail': 'Detail',
  'applications.text.bulkTask.all': 'Items',
  'applications.text.bulkTask.pending': 'Items - Pending',
  'applications.text.bulkTask.done': 'Items - Ok',
  'applications.text.bulkTask.failure': 'Items - Error',

  'applications.text.bulkTask.process': 'Process',
  'applications.text.bulkTask.number': 'Task No.',
  'applications.text.bulkTask.fileName': 'File',
  'applications.text.bulkTask.contentType': 'Content Type',
  'applications.text.bulkTask.status': 'Status',
  'applications.text.bulkTask.processingDate': 'Process Start Date',
  'applications.text.bulkTask.processedDate': 'Date Processed',
  'applications.text.bulkTask.observations': 'Observations',
  'applications.text.bulkTask.creator': 'User',
  'applications.text.bulkTask.created': 'Created Date',
  'applications.text.bulkTask.updated': 'Updated Date',
  'applications.text.bulkTask.block': 'Bulk Upload Task Details "{name}"',
  'applications.text.bulkTask.date': 'Date',
  'applications.text.bulkTask.lineNumber': 'Line Number',
  'applications.text.bulkTask.bulkRequestNumber': 'Request No. (Excel)',
  'applications.text.bulkTask.operation': 'Successful Operation?',
  'applications.text.bulkTask.request': 'Request',

  'applications.text.smtpId': 'Smtp Id',
  'applications.text.eventId': 'Event Id',
  'applications.text.messageId': 'Message Id',
  'applications.text.reason': 'Reason',
  'applications.text.userAgent': 'User Agent',

  'applications.text.bulkTaskType0': 'Pending',
  'applications.text.bulkTaskType1': 'Processing',
  'applications.text.bulkTaskType2': 'Processed',
  'applications.text.bulkTaskType3': 'Error',
  'applications.text.bulkTaskType4': 'Processing Task Items',
  'applications.text.bulkTaskType5': 'Canceled',

  'applications.text.dynamicEntityOperationType1': 'Search',
  'applications.text.dynamicEntityOperationType2': 'Add',
  'applications.text.dynamicEntityOperationType3': 'Modify',
  'applications.text.dynamicEntityOperationType4': 'Delete',
  'applications.text.dynamicEntityOperationType5': 'Count',
  'applications.text.dynamicEntityOperationType6': 'Sum',
  'applications.text.dynamicEntityOperationType7': 'Subtract',
  'applications.text.dynamicEntityOperationType8': 'Increase',
  'applications.text.dynamicEntityOperationType9': 'Decrease',
  'applications.text.dynamicEntityOperationType10': 'Evaluate Formula',

  'application.text.whatsAppBusinessOperationType.send-message': 'Send Message',

  'applications.text.engineVersionType1': 'V1',
  'applications.text.engineVersionType2': 'V2',

  'applications.text.actionType0': 'Default Initial',
  'applications.text.actionType1': 'Complete Information',
  'applications.text.actionType2': 'Approval',
  'applications.text.actionType3': 'Automatic Approval',
  'applications.text.actionType4': 'Conditional',
  'applications.text.actionType5': 'Execute Task',
  'applications.text.actionType6': 'Execute API Call',
  'applications.text.actionType7': 'Automatic Rejection',
  'applications.text.actionType8': 'Digital Signature',
  'applications.text.actionType9': 'Send Email',
  'applications.text.actionType10': 'Execute Database Query',
  'applications.text.actionType11': 'Operation on Dynamic Entity',
  'applications.text.actionType12': 'Generate Excel',
  'applications.text.actionType13': 'Start Process',
  'applications.text.actionType14': 'Set Variable',
  'applications.text.actionType15': 'Set Form Data',
  'applications.text.actionType16': 'Parallel',
  'applications.text.actionType17': 'Generate Documents',
  'applications.text.actionType18': 'Scheduled Execution',
  'applications.text.actionType19': 'SharePoint Operation',
  'applications.text.actionType20': 'Iterate / Apply to Each',
  'applications.text.actionType21': 'Switch',
  'applications.text.actionType22': 'Internal Operation',
  'applications.text.actionType23': 'Generate Text File',
  'applications.text.actionType24': 'Import Plain Text File',
  'applications.text.actionType25': 'Consume Sequence',
  'applications.text.actionType26': 'Execute RPA Flow',
  'applications.text.actionType27': 'Integration',
  'applications.text.actionType28': 'Automatic Cancel',
  'applications.text.actionType29': 'Automatic Annulment',
  'applications.text.actionType30': 'Open AI',
  'applications.text.actionType31': 'Execute Process Action',
  'applications.text.actionType32': 'Google Integration',
  'applications.text.actionType33': 'Revert Cancellation',
  'applications.text.actionType34': 'Revert Voiding',
  'applications.text.actionType35': 'FTP Operation',
  'applications.text.actionType36': 'Run Code',
  'applications.text.actionType37': 'Automy AI',
  'applications.text.actionType38': 'WhatsApp Business Integration',

  // Action descriptions for process configuration
  'actions.description.defaultInitial': 'Initial action of the process',
  'actions.description.completeInformation': 'Allows completing information through forms',
  'actions.description.approval': 'Requires manual approval from a user',
  'actions.description.autoApprove': 'Automatically approves without manual intervention',
  'actions.description.conditional': 'Evaluates conditions to determine flow',
  'actions.description.executeTask': 'Executes a specific system task',
  'actions.description.executeApiCall': 'Makes calls to external APIs',
  'actions.description.autoReject': 'Automatically rejects without manual intervention',
  'actions.description.digitalSignature': 'Requires digital signature from user',
  'actions.description.sendEmail': 'Sends emails automatically',
  'actions.description.executeQuery': 'Executes database queries',
  'actions.description.dynamicEntityOperation': 'Performs operations on dynamic entities',
  'actions.description.generateExcel': 'Generates Excel files with data',
  'actions.description.startProcessInstance': 'Starts a new process instance',
  'actions.description.setVariableData': 'Sets process variable values',
  'actions.description.setFormData': 'Sets data in forms',
  'actions.description.parallel': 'Executes multiple actions in parallel',
  'actions.description.generateDocuments': 'Generates documents based on templates',
  'actions.description.scheduledExecution': 'Schedules execution for a specific time',
  'actions.description.sharePointOperation': 'Performs SharePoint operations',
  'actions.description.iterate': 'Iterates over data collections',
  'actions.description.switch': 'Evaluates multiple conditions like switch',
  'actions.description.internalOperation': 'Executes internal system operations',
  'actions.description.generatePlainTextFile': 'Generates plain text files',
  'actions.description.importPlainTextFile': 'Imports data from text files',
  'actions.description.consumeSequence': 'Consumes data sequences',
  'actions.description.executeRpaFlow': 'Executes RPA automation flows',
  'actions.description.integration': 'Performs integrations with external systems',
  'actions.description.autoCancel': 'Automatically cancels the process',
  'actions.description.autoVoid': 'Automatically voids the process',
  'actions.description.openAI': 'Integration with OpenAI services',
  'actions.description.executeProcessAction': 'Executes actions from other processes',
  'actions.description.googleIntegration': 'Integration with Google services',
  'actions.description.revertCancellation': 'Reverts process cancellation',
  'actions.description.revertVoiding': 'Reverts process voiding',
  'actions.description.ftpOperation': 'Performs FTP file operations',
  'actions.description.runCode': 'Executes custom code',
  'actions.description.automyAI': 'Integration with Automy AI',
  'actions.description.whatsAppBusinessIntegration': 'Integration with WhatsApp Business',
  'actions.description.default': 'Process action',

  'applications.text.logicalOperatorType0': 'OR',
  'applications.text.logicalOperatorType1': 'AND',

  'applications.text.myRequests': 'My Requests',
  'applications.text.receivedRequests': 'Received',
  'applications.text.revisionRequests': 'Revision',
  'applications.text.allRequests': 'All',
  'applications.text.bulkRequests': 'Bulk Upload',

  'applications.text.cancellationReason': 'Cancellation Reason',
  'applications.text.rejectedReason': 'Rejection Reason',
  'applications.text.voidedReason': 'Voided Reason',

  'applications.text.requestType0': 'Request on Evaluation',
  'applications.text.requestType1': 'Request Approved',
  'applications.text.requestType2': 'Request Rejected',
  'applications.text.requestType3': 'Request Canceled',
  'applications.text.requestType4': 'Request Voided',
  'applications.text.requestType5': 'Request with Error',

  'applications.text.actionType.0': 'Initiated By',
  'applications.text.actionType.1': 'Form',
  'applications.text.actionType.3': 'Action automatically approved by the system',
  'applications.text.actionType.4': 'Approval Result',
  'applications.text.actionType.7': 'Action automatically rejected by the system',
  'applications.text.actionType.6': 'API Connection',
  'applications.text.actionType.10': 'Database Connection',
  'applications.text.actionType.11': 'Dynamic Entity',
  'applications.text.actionType.13': 'Process',
  'applications.text.actionType.18': 'Scheduled Execution Date and Time',
  'applications.text.actionType.19': 'SharePoint Configuration',
  'applications.text.actionType.20': 'Data Source to Iterate',
  'applications.text.actionType.22': 'Internal Operation',
  'applications.text.actionType.23': 'Format',
  'applications.text.actionType.24': 'Format',
  'applications.text.actionType.25': 'Sequence',
  'applications.text.actionType.26': 'RPA Agent',
  'applications.text.actionType.27': 'Integration',
  'applications.text.actionType.28': 'Auto Cancel',
  'applications.text.actionType.29': 'Auto Annul',
  'applications.text.actionType.30': 'Open AI',
  'applications.text.actionType.31': 'Execute Action',
  'applications.text.actionType.32': 'Google Integration',
  'applications.text.actionType.33': 'Revert Cancellation',
  'applications.text.actionType.34': 'Revert Voiding',
  'applications.text.actionType.35': 'FTP Operation',
  'applications.text.actionType.36': 'Run Code',
  'applications.text.actionType.37': 'Handler Type',

  'applications.text.valueSourceType1': 'Form / Field',
  'applications.text.valueSourceType2': 'Variable',
  'applications.text.valueSourceType3': 'Current Step Iteration',

  'applications.text.originValue': 'Fixed Value',
  'applications.text.destinationForm': 'Destination Form',
  'applications.text.destinationField': 'Destination Field',
  'applications.text.value': 'Value',
  'applications.text.field': 'Field',
  'applications.text.variable': 'Variable',
  'applications.text.operator': 'Operator',
  'applications.text.conditionValue': 'Condition Value',
  'applications.text.evaluationValue': 'Evaluation Value',
  'applications.text.evaluationObservations': 'Result',
  'applications.text.valueSource': 'Value Source',

  'applications.text.actionInstanceStatus.3': 'Expiration Date and Time Reached',
  'applications.text.execution': 'Execution',

  'applications.text.responseError': 'Error Message',
  'applications.text.responseStatusCode': 'Response Code',
  'applications.text.responseData': 'Response Data',
  'applications.text.requestPayload': 'Sent Data',
  'applications.text.requestUrl': 'Request URL',

  'applications.text.sequencePattern': 'Sequence Pattern',
  'applications.text.sequenceItemPattern': 'Sequence Item Pattern',
  'applications.text.generatedNumber': 'Generated Number',
  'applications.text.sequenceItemId': 'Subsequence Identifier',
  'applications.text.sequenceTraceId': 'Sequence Trace Identifier',

  'applications.text.requestMethod0': '? ',
  'applications.text.requestMethod1': 'POST',
  'applications.text.requestMethod2': 'GET',
  'applications.text.requestMethod3': 'PUT',
  'applications.text.requestMethod4': 'DELETE',

  'applications.text.variableType1': 'Text',
  'applications.text.variableType2': 'Number',
  'applications.text.variableType3': 'Date and Time',
  'applications.text.variableType4': 'Date',
  'applications.text.variableType5': 'Time',
  'applications.text.variableType6': 'Matrix',
  'applications.text.variableType7': 'Document',

  'applications.text.startModeType1': 'Manual Flow',
  'applications.text.startModeType2': 'Automated Flow',
  'applications.text.startModeType3': 'Scheduled Flow',

  'applications.text.document.type': 'Type',
  'applications.text.document.user': 'Owner',
  'applications.text.document.filename': 'Name',
  'applications.text.document.created': 'Last Modified',
  'applications.text.document.size': 'File Size',
  'applications.text.document.contentType': 'Content Type',
  'applications.text.document.form': 'Form',
  'applications.text.document.field': 'Field',
  'applications.text.document.actionName': 'Action',

  'applications.text.Attachment': 'Attachment',
  'applications.text.Generated': 'Generated',
  'applications.text.VariableAttachment': 'Variable Attachment',
  'applications.text.TableAttachment': 'Table Attachment',
  'applications.text.CommentAttachment': 'Comment Attachment',

  'applications.text.email.detail': 'Email Traces Details',
  'applications.text.mail.event': 'Event',
  'applications.text.mail.date': 'Date',
  'applications.text.mail.type': 'Type',
  'applications.text.mail.address': 'Email',
  'applications.text.mail.smtpId': 'SmtpId',
  'applications.text.mail.subject': 'Subject',

  'applications.text.email.id': 'Id',
  'applications.text.email.messageType': 'Type',
  'applications.text.email.email': 'Email',
  'applications.text.email.eventDate': 'Event Date',
  'applications.text.email.subject': 'Subject',
  'applications.text.email.smtpId': 'SmtpId',
  'applications.text.email.eventId': 'EventId',
  'applications.text.email.messageId': 'MessageId',
  'applications.text.email.mailEventDescription': 'Event',
  'applications.text.email.mailEventLongDescription': 'Description',
  'applications.text.email.created': 'Creation Date',
  'applications.text.email.status': 'Status',
  'applications.text.email.reason': 'Reason',
  'applications.text.email.userAgent': 'User Agent',
  'applications.text.email.ip': 'IP',
  'applications.text.email.environment': 'Environment',

  'applications.text.email.status.sent': 'Sent',
  'applications.text.email.status.badRequest': 'Bad Request',
  'applications.text.email.status.unauthorized': 'Unauthorized',
  'applications.text.email.status.forbidden': 'Forbidden',
  'applications.text.email.status.notFound': 'Not Found',
  'applications.text.email.status.payloadTooLarge': 'Payload Too Large',
  'applications.text.email.status.tooManyRequests': 'Too Many Requests',
  'applications.text.email.status.internalServerError': 'Internal Server Error',
  'applications.text.email.status.badGateway': 'Bad Gateway',
  'applications.text.email.status.serviceUnavailable': 'Service Unavailable',
  'applications.text.email.status.gatewayTimeout': 'Gateway Timeout',
  'applications.text.email.status.unknown': 'Unknown',

  'applications.text.emailType.unknown': 'Unknown',
  'applications.text.emailType.processInstancePendingApproval': 'Request / Pending Approval',
  'applications.text.emailType.processInstancePendingCompleteInformation':
    'Request / Pending Completion Information',
  'applications.text.emailType.processInstancePendingTaskCompletion': 'Request / Pending Task',
  'applications.text.emailType.processInstancePendingSignature': 'Request / Pending Signature',
  'applications.text.emailType.processInstanceApprovalSecurityCode': 'Request / Approval Code',
  'applications.text.emailType.processInstanceActionSendEmail': 'Request / Send Email Action',
  'applications.text.emailType.processInstanceNewCommentNotification':
    'Request / New Comment Notification',
  'applications.text.emailType.processInstanceScheduledExecutionNotification':
    'Request / Scheduled Execution Notification',
  'applications.text.emailType.processInstanceApprovedNotification':
    'Request / Approved Notification',
  'applications.text.emailType.processInstanceRejectedNotification':
    'Request / Rejected Notification',
  'applications.text.emailType.processInstanceCanceledNotification':
    'Request / Canceled Notification',
  'applications.text.emailType.processInstanceVoidedNotification':
    'Request / Annulled Notification',
  'applications.text.emailType.processInstanceWithErrorsNotification':
    'Request / Error Notification',
  'applications.text.emailType.userAccountConfirmation': 'User / Account Confirmation',
  'applications.text.emailType.userAccountWelcomeMessage': 'User / Welcome Message',
  'applications.text.emailType.userAccountResetPassword': 'User / Change Password',
  'applications.text.emailType.userAccountTwoFactorValidationCode':
    'User / Two-Factor Authentication Code',
  'applications.text.emailType.userAccountSecurityAlertNewLogin': 'User / New Access Alert',
  'applications.text.emailType.internalTaskErrorNotification': 'Internal Task / Error Notification',
  'applications.text.emailType.internalTaskEntityFileReadyToDownloadNotification':
    'Internal Task / Notification Dynamic Entity File Ready to Download',
  'applications.text.emailType.internalTaskEntityFileImportFinishNotification':
    'Internal Task / Notification Dynamic Entity Import Finished',
  'applications.text.emailType.formFieldApiWithErrorsNotification':
    'Form API Field / API Notification with Errors',
  'applications.text.emailType.maintenanceCompanyDeactivationNotification':
    'Maintenance / Company Deactivation Notice',
  'applications.text.emailType.processInstanceReassigned': 'Request / Task Reassigned',
  'applications.text.emailType.systemReportInternalTaskCompletedNotification':
    'Internal Task / Notification Completed',
  'applications.text.emailType.taskAssigned': 'Assigned Task',
  'applications.text.emailType.internalTaskDynamicEntityImportCompleted':
    'Internal Task / Notification Dynamic Entity Import Completed',
  'applications.text.emailType.agentEmailMessage': 'Agent / Email Message',

  'applications.text.emailEventundefined': 'Unknown',
  'applications.text.emailEvent.processed': 'Processed',
  'applications.text.emailEvent.dropped': 'Abandoned',
  'applications.text.emailEvent.delivered': 'Delivered',
  'applications.text.emailEvent.bounce': 'Bounced',
  'applications.text.emailEvent.deferred': 'Deferred',
  'applications.text.emailEvent.open': 'Opened',
  'applications.text.emailEvent.click': 'Clicked',
  'applications.text.emailEvent.unsubscribe': 'Unsubscribe',
  'applications.text.emailEvent.resubscribe': 'Resubscribe',
  'applications.text.emailEvent.spamReport': 'Span Report',

  'applications.text.mailEventLongDescription': 'Description',
  'applications.text.mailEventLongDescription0':
    'Message has been received and is ready to be delivered',
  'applications.text.mailEventLongDescription1':
    'You may see the following drop reasons: Invalid SMTPAPI header, Spam Content (if Spam Checker app is enabled), Unsubscribed Address, Bounced Address, Spam Reporting Address, Invalid, Recipient List over Package Quota',
  'applications.text.mailEventLongDescription2':
    'Message has been successfully delivered to the receiving server',
  'applications.text.mailEventLongDescription3':
    'Receiving server could not or would not accept mail to this recipient permanently. If a recipient has previously unsubscribed from your emails, the message is dropped',
  'applications.text.mailEventLongDescription4':
    'Receiving server temporarily rejected the message',
  'applications.text.mailEventLongDescription5':
    'Recipient has opened the HTML message. Open Tracking needs to be enabled for this type of event',
  'applications.text.mailEventLongDescription6':
    'Recipient clicked on a link within the message. Click Tracking needs to be enabled for this type of event',
  'applications.text.mailEventLongDescription7':
    "Recipient clicked on the 'Opt Out of All Emails' link (available after clicking the message's subscription management link). Subscription Tracking needs to be enabled for this type of event",
  'applications.text.mailEventLongDescription8': '',
  'applications.text.mailEventLongDescription9': 'Recipient marked message as spam',

  'applications.text.operationType.search': 'Search',
  'applications.text.operationType.add': 'Add',
  'applications.text.operationType.modify': 'Modify',
  'applications.text.operationType.delete': 'Delete',
  'applications.text.operationType.remove': 'Remove',
  'applications.text.operationType.count': 'Count',
  'applications.text.operationType.sum': 'Sum',
  'applications.text.operationType.subtract': 'Subtract',
  'applications.text.operationType.increase': 'Increase',
  'applications.text.operationType.decrement': 'Decrease',
  'applications.text.operationType.evaluate-formula': 'Evaluate Formula',

  'applications.text.dynamicEntityOperationType.search': 'Search',
  'applications.text.dynamicEntityOperationType.add': 'Add',
  'applications.text.dynamicEntityOperationType.modify': 'Modify',
  'applications.text.dynamicEntityOperationType.remove': 'Delete',
  'applications.text.dynamicEntityOperationType.count': 'Count',
  'applications.text.dynamicEntityOperationType.sum': 'Sum',
  'applications.text.dynamicEntityOperationType.subtraction': 'Subtraction',
  'applications.text.dynamicEntityOperationType.increment': 'Increment',
  'applications.text.dynamicEntityOperationType.decrement': 'Decrement',
  'applications.text.dynamicEntityOperationType.evaluateformula': 'Evaluate Formula',
  'applications.text.dynamicEntityOperationType.evaluate-formula': 'Evaluate Formula',
  'applications.text.internalOperationType.search': 'Search',
  'applications.text.internalOperationType.add': 'Add',
  'applications.text.internalOperationType.modify': 'Modify',
  'applications.text.internalOperationType.activate': 'Activate',
  'applications.text.internalOperationType.deactivate': 'Deactivate',
  'applications.text.internalOperationType.remove': 'Delete',
  'applications.text.internalOperationType.count': 'To count',
  'applications.text.internalOperationType.cancel-delegation': 'Revoke Delegation',

  'application.text.sharePointOperationType1': 'Upload File',
  'application.text.sharePointOperationType.upload-file': 'Upload File',

  'applications.text.iterationDataSourceType1': 'Form Table',
  'applications.text.iterationDataSourceType2': 'Dynamic Entity',
  'applications.text.iterationDataSourceType3': 'Form Field Attachment',
  'applications.text.iterationDataSourceType.form-table': 'Form Table',
  'applications.text.iterationDataSourceType.dynamic-entity': 'Dynamic Entity',
  'applications.text.iterationDataSourceType.form-field-attachment': 'Form Field Attachment',

  'applications.text.internalOperationEntityType.user': 'User',
  'applications.text.internalOperationEntityType.position': 'Position',
  'applications.text.internalOperationEntityType.area': 'Area',
  'applications.text.internalOperationEntityType.user-group': 'User Group',
  'applications.text.internalOperationEntityType.user-group-user': 'User Group User',
  'applications.text.internalOperationEntityType.environment': 'Environment',
  'applications.text.internalOperationEntityType.chat-thread-participant': 'Chat Participant',
  'applications.text.internalOperationEntityType.ai-agent-vector': 'AI Agent / Training Vector',
  'applications.text.internalOperationEntityType.environment-user': 'Environment User',
  'applications.text.internalOperationEntityType.delegation': 'Delegation',
  'applications.text.internalOperationEntityType.delegation-configuration':
    'Delegation Configuration',
  'applications.text.internalOperationEntityType.global-entity-approver-by-areas':
    'Global Entity Approver By Areas',
  'applications.text.internalOperationEntityType.global-entity-approver-by-positions':
    'Global Entity Approver By Positions',
  'applications.text.internalOperationEntityType.global-entity-approver-by-user-groups':
    'Global Entity Approver By User Groups',
  'applications.text.internalOperationEntityType.global-entity-approver-by-users':
    'Global Entity Approver Users',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-areas':
    'Global User Group Approver By Areas',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-positions':
    'Global User Group Approver By Positions',
  'applications.text.internalOperationEntityType.global-user-group-approver-by-users':
    'Global User Group Approver Users',
  'applications.text.internalOperationEntityType.report-trace': 'Report Trace',
  'applications.text.internalOperationEntityType.internal-task': 'Internal Task',
  'applications.text.internalOperationEntityType.process-instance': 'Process Instance',

  'applications.text.internalOperationEntityType1': 'User',
  'applications.text.internalOperationEntityType2': 'Position',
  'applications.text.internalOperationEntityType3': 'Area',
  'applications.text.internalOperationEntityType4': 'User Group',
  'applications.text.internalOperationEntityType5': 'User Group User',
  'applications.text.internalOperationEntityType6': 'Environment',
  'applications.text.internalOperationEntityType7': 'Environment User',
  'applications.text.internalOperationEntityType8': 'Delegation',
  'applications.text.internalOperationEntityType9': 'Delegation Configuration',
  'applications.text.internalOperationEntityType10': 'Global Entity Approver By Areas',
  'applications.text.internalOperationEntityType11': 'Global Entity Approver By Positions',
  'applications.text.internalOperationEntityType12': 'Global Entity Approver By User Groups',
  'applications.text.internalOperationEntityType13': 'Global Entity Approver Users',
  'applications.text.internalOperationEntityType14': 'Global User Group Approver By Areas',
  'applications.text.internalOperationEntityType15': 'Global User Group Approver By Positions',
  'applications.text.internalOperationEntityType16': 'Global User Group Approver Users',
  'applications.text.internalOperationEntityType17': 'Report Trace',
  'applications.text.internalOperationEntityType18': 'Internal Task',
  'applications.text.internalOperationEntityType19': 'Process Instance',
  'applications.text.internalOperationEntityType20': 'Chat Participant',
  'applications.text.internalOperationEntityType21': 'AI Agent / Training Vector',

  'applications.text.processInstanceFormFieldAttachment': 'Attachment',
  'applications.text.processInstanceGeneratedDocument': 'Generated Document',
  'applications.text.processInstanceVariableAttachment': 'Attachment',
  'applications.text.processInstanceCommentAttachment': 'Attachment',
  'applications.text.entityAttachment': 'Attachment',
  'applications.text.processInstanceApiCallAttachment': 'Attachment',
  'applications.text.listExportGeneratedFile': 'Generated File',
  'applications.text.entityExportGeneratedFile': 'Generated File',
  'applications.text.entityImportGeneratedErrorFile': 'Generated Error File',
  'applications.text.processInstanceOpenAICallAttachment': 'Attachment',
  'applications.text.processInstanceAutomyAIAttachment': 'Attachment',
  'applications.text.processInstanceRunCodeAttachment': 'Attachment',
  'applications.text.chatThreadAttachment': 'Attachment',

  'applications.text.actionInstanceStatus0': 'Pending',
  'applications.text.actionInstanceStatus1': 'Sent',
  'applications.text.actionInstanceStatus2': 'Error',

  'applications.text.action.instanceStatus0': 'Pending',
  'applications.text.action.instanceStatus1': 'Completed',
  'applications.text.action.instanceStatus2': 'Rejected',
  'applications.text.action.instanceStatus3': 'Expired',
  'applications.text.action.instanceStatus4': 'Omitted',
  'applications.text.action.instanceStatus5': 'Error',
  'applications.text.action.instanceStatus6': 'Executed',

  'applications.text.comparisonOperatorType1': 'Equal',
  'applications.text.comparisonOperatorType2': 'Not Equal',
  'applications.text.comparisonOperatorType3': 'Greater Than',
  'applications.text.comparisonOperatorType4': 'Greater Than or Equal',
  'applications.text.comparisonOperatorType5': 'Less Than',
  'applications.text.comparisonOperatorType6': 'Less Than or Equal',
  'applications.text.comparisonOperatorType7': 'Contains',
  'applications.text.comparisonOperatorType8': 'Does Not Contain',
  'applications.text.comparisonOperatorType9': 'Is Null',
  'applications.text.comparisonOperatorType10': 'Is Not Null',

  'applications.text.plainTextFileFormat.json': 'JSON',
  'applications.text.plainTextFileFormat.text': 'TXT',
  'applications.text.plainTextFileFormat.csv': 'CSV',
  'applications.text.plainTextFileFormat.xml': 'XML',
  'applications.text.plainTextFileFormat.parquet': 'PARQUET',

  'applications.text.statusDate': 'Date',
  'applications.text.statusReason': 'Rejection Reason',
  'applications.text.statusUser': 'User',

  'applications.text.message.success': 'Request {name} was {action} successfully',
  'applications.text.message.error': 'Request {name} could not be {action}',
  'applications.text.message.processInstanceStatusChange':
    'The request status has changed, you will be redirected to the details view shortly.',

  'applications.text.message.commandType1': 'approved',
  'applications.text.message.commandType2': 'rejected',
  'applications.text.message.commandType3': 'completed',
  'applications.text.message.commandType4': 'executed',
  'applications.text.message.commandType5': 'signed',
  'applications.text.message.commandType6': 'canceled',
  'applications.text.message.commandType7': 'voided',
  'applications.text.message.commandType8': 'sent',
  'applications.text.message.commandType9': 'evaluated',
  'applications.text.message.commandType10': 'reverted',
  'applications.text.message.commandType11': 'reassigned',
  'applications.text.message.commandType12': 'executed',
  'applications.text.message.commandType15': 'assigned',
  'applications.text.message.commandType28': 'canceled',
  'applications.text.message.commandType29': 'voided',

  'applications.text.googleIntegrationOperationType1': 'Upload File',
  'applications.text.googleIntegrationOperationType2': 'Download File',

  'application.text.googleOperationType.download-file': 'Download File',
  'application.text.googleOperationType.upload-file': 'Upload File',
  'application.text.googleServiceType.google-drive': 'Google Drive',

  'application.text.fptOperationType.download-file': 'Download File',
  'application.text.fptOperationType.upload-file': 'Upload File',

  'applications.text.openAIOperationType.parser': 'Parser',
  'applications.text.openAi.extra': 'Model',
  'applications.text.openAi.description': 'Operation',

  'applications.text.automyAIHandlerType.agent': 'Agent',
  'applications.text.automyAIHandlerType.completions': 'Completions',
  'applications.text.automyAIHandlerType.responses': 'Responses',
  'applications.text.automyAi.extra': 'Model',

  'applications.text.automyAIHandlerType.1': 'Completions',
  'applications.text.automyAIHandlerType.2': 'Agent',
  'applications.text.automyAIHandlerType.3': 'Responses',

  'applications.text.importPlainTextFile.description': 'Source Form',
  'applications.text.importPlainTextFile.extra': 'Source Field',

  'applications.text.resourceType1': 'User',
  'applications.text.resourceType2': 'External User',
  'applications.text.resourceType3': 'Webhook',
  'applications.text.resourceType4': 'Process Instance Action Start Process',
  'applications.text.resourceType5': 'ProcessTrigger',
  'applications.text.resourceType6': 'Scheduled Process',
  'applications.text.resourceType7': 'Bulk Task',
  'applications.text.id': 'Identifier',
  'applications.text.actionInstanceId': 'Action Instance Identifier',

  'applications.text.opsResultStatusType0': 'Pending',
  'applications.text.opsResultStatusType1': 'Executing',
  'applications.text.opsResultStatusType2': 'Success',
  'applications.text.opsResultStatusType3': 'Error',
  'applications.text.opsResultStatusType4': 'Failed',

  'applications.text.operationResultStatus.pending': 'Pending',
  'applications.text.operationResultStatus.executing': 'Executing',
  'applications.text.operationResultStatus.success': 'Success',
  'applications.text.operationResultStatus.error': 'Error',
  'applications.text.operationResultStatus.failed': 'Failed',

  'applications.text.automyAIHandlerType.completions': 'Completions',
  'applications.text.automyAIHandlerType.agent': 'Agent',
  'applications.text.automyAIHandlerType.responses': 'Responses',
};
